import { PortalBlockPlace } from '@nx-frontend/shared/types/portal-block';

export const isHeaderBlockPlace = (place: PortalBlockPlace): boolean => {
  return place === 'page_header' || place === 'global_header';
};

export const isBodyBlockPlace = (place: PortalBlockPlace): boolean => {
  return place === 'page_body' || place === 'page_body_top' || place === 'page_body_bottom' || place === 'global_body';
};

export const isBodyContentBlockPlace = (place: PortalBlockPlace): boolean => {
  return place === 'page_body' || place === 'global_body';
};

export const isFooterBlockPlace = (place: PortalBlockPlace): boolean => {
  return place === 'page_footer' || place === 'global_footer';
};
